export class Input {
    constructor({ input, event, handler }) {
        this._input = input;

        if (event) {
            this._handler = handler.bind(this);
            $(this._input).on(event, this._handler);
        }
    }

    setValue(value) {
        $(this._input).val(value);
    }

    getValue() {
        return $(this._input).val();
    }

    destroy() {
        $(this._input).off();
    }
}